<template>
  <div class="row">
    <div class="form-group col-xs-12 col-md-12 mt-4">
      <w-select
        :model="schema.frequencyType"
        :values="frequencyTypes"
        :title="$t('schema.minimalSchedule.frequency')"
        @input="clearData"
      />
    </div>

    <template v-if="schema.frequencyType.$model">
      <template v-if="scheduleType === MinimalScheduleType.TRENING">
        <div class="form-group col-md-4">
          <w-input :model="schema.duration" :title="$t(schema.duration.$schema.title)" />
        </div>

        <div class="form-group col-md-4">
          <w-input :model="schema.hour" :title="$t(schema.hour.$schema.title)" />
        </div>

        <div class="form-group col-md-4">
          <w-input :model="schema.minute" :title="$t(schema.minute.$schema.title)" />
        </div>
      </template>

      <div v-if="schema.frequencyType.$model !== MinimalScheduleFrequency.ONCE" class="form-group col-xs-12 col-md-12">
        <form-datepicker :model="schema.end" :title="$t(schema.end.$schema.title)" />
      </div>

      <div
        v-if="schema.day.$schema.fieldRequired && schema.frequencyType.$model === MinimalScheduleFrequency.WEEKLY"
        class="form-group col-md-4"
      >
        <w-select title="Dzień tygodnia*" :model="schema.day" :values="weekDays" />
      </div>

      <div
        v-if="
          schema.day.$schema.fieldRequired &&
            (schema.frequencyType.$model === MinimalScheduleFrequency.MONTHLY ||
              schema.frequencyType.$model === MinimalScheduleFrequency.YEARLY)
        "
        class="form-group col-md-4"
      >
        <w-input title="Dzień miesiąca*" :model="schema.day" />
      </div>

      <div v-if="schema.month.$schema.fieldRequired" class="form-group col-md-4">
        <w-select :model="schema.month" :values="months" :title="$t(schema.month.$schema.title)" />
      </div>
    </template>
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';
import moment from 'moment';

import FormDatepicker from '@/components/FormDatepicker.vue';
import { Months, MonthsTranslation } from '@/enums/month.enum';
import { Week, WeekTranslation } from '@/enums/week.enum';
import { MinimalScheduleFrequency, MinimalScheduleFrequencyTranslation } from '@/enums/minimalScheduleFrequency.enum';
import { MinimalScheduleType } from '@/enums/minimalScheduleType.enum';

const emptyFrequencyData = () => ({
  frequency: 1,
  day: null,
  month: null,
  week: null,
  hour: 0,
  minute: 0,
  duration: null
});

// @vuese
// Formularz harmonogramu składowego
// @group Components
export default {
  props: {
    // Schema
    schema: {
      type: Object,
      required: true
    },
    // Data
    date: {
      type: Date,
      required: true
    },
    // Rodzaj harmonogramu
    scheduleType: {
      type: String,
      required: true
    }
  },
  components: {
    ...components,
    FormDatepicker
  },
  data() {
    return {
      MinimalScheduleFrequency,
      MinimalScheduleType
    };
  },
  methods: {
    // @vuese
    // Czyści dane i wypełnia je datami z kalendarza
    clearData() {
      const frequencyData = emptyFrequencyData();

      if (this.schema.frequencyType.$model === MinimalScheduleFrequency.ONCE) {
        this.schema.end.$model = moment(this.date).format('YYYY-MM-DD');
      }

      this.setTime(frequencyData);
      this.setDay(frequencyData);
      this.setMonth(frequencyData);

      this.schema.$setData({ ...frequencyData });
    },
    // @vuese
    // Ustawia czas
    setTime(frequencyData) {
      if (this.scheduleType === MinimalScheduleType.TRENING) {
        frequencyData.hour = parseInt(moment(this.date).format('HH'));
        frequencyData.minute = parseInt(moment(this.date).format('mm'));
      } else {
        // Ustawia cały dzień
        frequencyData.duration = 1440;
      }
    },
    // @vuese
    // Ustawia dzień
    setDay(frequencyData) {
      if (this.schema.frequencyType.$model === MinimalScheduleFrequency.WEEKLY) {
        frequencyData.day = moment(this.date)
          .locale('he-IL')
          .weekday();
      } else if (
        this.schema.frequencyType.$model === MinimalScheduleFrequency.MONTHLY ||
        this.schema.frequencyType.$model === MinimalScheduleFrequency.YEARLY
      ) {
        frequencyData.day = parseInt(moment(this.date).format('DD'));
      }
    },
    // @vuese
    // Ustawia miesiąc
    setMonth(frequencyData) {
      if (this.schema.frequencyType.$model === MinimalScheduleFrequency.YEARLY) {
        frequencyData.month = moment(this.date).month();
      }
    }
  },
  computed: {
    months() {
      return Object.keys(Months)
        .filter(key => !isNaN(key))
        .map(month => ({
          value: month,
          text: this.$t(MonthsTranslation[month])
        }));
    },
    weekDays() {
      const days = Object.keys(Week)
        .filter(key => !isNaN(key))
        .map(weekDay => ({
          value: weekDay,
          text: this.$t(WeekTranslation[weekDay])
        }));
      const sunday = days.shift();
      days.push(sunday);
      return days;
    },
    frequencyTypes() {
      return Object.keys(MinimalScheduleFrequency).map(frequencyType => ({
        value: MinimalScheduleFrequency[frequencyType],
        text: this.$t(MinimalScheduleFrequencyTranslation[MinimalScheduleFrequency[frequencyType]])
      }));
    }
  },
  watch: {
    date(val) {
      if (val) {
        this.clearData();
      }
    },
    scheduleType(val) {
      if (val) {
        this.clearData();
      }
    }
  }
};
</script>
